import React, { useEffect, useState } from 'react';
import { Segment, Header, Pagination } from 'semantic-ui-react'
import TitleBar from '../../components/titleBar/title_bar'
import LoadingPlaceholder from '../placeholderComponent/loadingPlaceholder'
import AgGridTable from '../../components/agGridComponent/agGridTable';
import DocumentActionButton from './documentActionButton';



export default function ListVehicles(props){

    const [isUpdated, setisUpdated] = useState(false)
    const [currentPage, setCurrentPage] = useState(1)
    const [totalPages, setTotalPages] = useState(1)
    const [limit, setLimit] = useState(10)
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }

    const [searchValue, setsearchValue] = useState('')
    let handleSearch = (e, data) => {
        // console.log(data)
        setsearchValue(data.value)
    }
    const handlePaginationChange = (e, { activePage }) => {
        setCurrentPage(activePage)
        props.getVehicleDocuments(activePage, limit)
      };

    useEffect(()=>{
        if(props.paginationData?.totalRecords){
            let totalPages = Math.ceil(Number(props.paginationData?.totalRecords)/limit)
            setTotalPages(totalPages)
        }
    },[props.paginationData])

    const { vehicleList, isLoading } = props;
    

    if(isLoading){
        return (
            <React.Fragment>
                <TitleBar title="Document" LinkName="/add-document" />
                <LoadingPlaceholder />
            </React.Fragment>
        )

    } else {

        let columnDefs = [
            { hide: true, headerName: 'Vehicle Id', field: 'vehicleid' },
            { headerName: 'Vehicle No.', field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Vehicle Type', field: 'vehtype', tooltipField: 'vehtype', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Branch', field: 'branch', tooltipField: 'branch', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Active Docs', field: 'actdocs', tooltipField: 'actdocs', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Expired Docs', field: 'expdocs', tooltipField: 'expdocs', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'Docs. Expiring Soon', field: 'docexpsoon', tooltipField: 'docexpsoon', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: 'History/Edit', field: 'edit', cellRenderer: 'actionRenderer', width: 280, suppressToolPanel: true, pinned: "right" },
            

        ]

        let rowData = []
        vehicleList && vehicleList.map((object, index) => {
            let temp = {}
            temp.code = object.vehicleNumber
            temp.vehtype = object.vehicle_type ? object.vehicle_type.vehicleType : ''
            temp.branch = object.branchObj ? object.branchObj.branchName : ''
            temp.actdocs = object.docActiveCount
            temp.expdocs = object.docExpiredCount
            temp.docexpsoon = object.docExpiredSoonCount
            temp.vehicleid = object.vehicleMasterId
            rowData[index] = temp
        })

        let frameworkComponents = {
            actionRenderer: DocumentActionButton,
        }
        
        return (
            <React.Fragment>
                <div className="ag-theme-material agOver ">
                    <AgGridTable
                        columnDefs={columnDefs}
                        rowData={rowData}
                        searchValue={searchValue}
                        extraComponents={frameworkComponents}
                        reload={getUpdate}
                        link="/add-document"
                        hiddenNewPopupBtn={true}
                        hiddenImportPopupBtn={true}
                        BaseUrl={props}
                        titleBarTitle="Document"
                        handleSearch={handleSearch}
                        pagination={false}
                    />
                </div>
                <Pagination
                    defaultActivePage={currentPage}
                    firstItem={null}
                    lastItem={null}
                    onPageChange={handlePaginationChange}
                    pointing
                    secondary
                    totalPages={totalPages}
                />
            </React.Fragment>
        )
    }
}
